import {forwardRef, MouseEventHandler, ReactNode} from 'react';
import styles from './index.module.scss';

export interface IIconButtonProps {
  children: ReactNode | ReactNode[];
  color: string;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

const IconButton = forwardRef<HTMLButtonElement, IIconButtonProps>(
  ({
     children, color, disabled = false, onClick = () => {
    }
   }, ref) => (
    <button
      ref={ref}
      onClick={onClick}
      disabled={disabled}
      style={{color, cursor: disabled ? 'not-allowed' : 'pointer'}}
      type='button'
      className={styles.iconButton}
    >
      {children}
    </button>
  )
);

export default IconButton;
